import { render, staticRenderFns } from "./SasvView.vue?vue&type=template&id=2c945913"
import script from "./SasvView.vue?vue&type=script&lang=js"
export * from "./SasvView.vue?vue&type=script&lang=js"
import style0 from "./SasvView.vue?vue&type=style&index=0&id=2c945913&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports